import { render, staticRenderFns } from "./nanjing-old.vue?vue&type=template&id=b4165bec&scoped=true"
import script from "./nanjing-old.vue?vue&type=script&lang=js"
export * from "./nanjing-old.vue?vue&type=script&lang=js"
import style0 from "./nanjing-old.vue?vue&type=style&index=0&id=b4165bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4165bec",
  null
  
)

export default component.exports